<template>
  <v-card
    class="question-card custom-elevation custom-border"
  >
    <v-card-text>
      {{ question.definition }}
    </v-card-text>
  </v-card>
</template>

<style scoped>
.question-card .v-card__text {
  font-size: 1.4em;
  line-height: 1.8rem;
  color: black;
}

.answer-success .question-card,
.answer-success .question-card .v-card__text {
  background: var(--v-success-lighten4);
  color: var(--v-success-darken1);
}

.answer-error .question-card {
  background: var(--v-primary-lighten4);
  color: var(--v-error-base);
}

@media screen and (max-width: 410px) {
  .question-card .v-card__text {
    font-size: 1.2em;
  }
}
</style>

<script>
export default {
  name: 'QuestionCard',
  props: {
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    question() {
      return this.$store.getters['rondo/current'] || {};
    },
  },
};
</script>
